var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "box" } },
    [
      _c("Header"),
      _c(
        "a-row",
        [
          _c("a-col", { attrs: { span: 4 } }),
          _c("a-col", { attrs: { span: 16 } }, [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "flex-direction": "column",
                  width: "100%",
                  "margin-top": "30px",
                },
              },
              [
                _c("div", { staticClass: "login_title" }),
                _c(
                  "div",
                  { staticClass: "login" },
                  [
                    _c(
                      "a-form",
                      [
                        _c(
                          "a-form-item",
                          {
                            staticStyle: { "margin-bottom": "30px" },
                            attrs: { label: "" },
                          },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入注册手机号码" },
                              model: {
                                value: _vm.form.username,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "username", $$v)
                                },
                                expression: "form.username",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "a-form-item",
                          { attrs: { label: "" } },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "请输入密码",
                                "show-password": "",
                              },
                              model: {
                                value: _vm.form.password,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "password", $$v)
                                },
                                expression: "form.password",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "a-form-item",
                          [
                            _c(
                              "a-button",
                              {
                                staticStyle: {
                                  width: "100%",
                                  height: "35px",
                                  background: "red",
                                  "border-color": "red",
                                },
                                attrs: { type: "danger" },
                                on: { click: _vm.login },
                              },
                              [_vm._v("登录 ")]
                            ),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "bottom_button" }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                width: "50%",
                                "text-align": "left",
                                color: "#132b75",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.modify()
                                },
                              },
                            },
                            [_vm._v("忘记密码？")]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                width: "50%",
                                "text-align": "right",
                              },
                            },
                            [
                              _vm._v("没有账号"),
                              _c(
                                "span",
                                {
                                  staticStyle: { color: "#132b75" },
                                  on: { click: _vm.homepay },
                                },
                                [_vm._v("点此注册")]
                              ),
                            ]
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
          ]),
          _c("a-col", { attrs: { span: 4 } }),
        ],
        1
      ),
      _c("Footer"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }